// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__0Vfbl","subHeading":"styles_subHeading__XjxY9","fadeInOut":"styles_fadeInOut__zSGzy","loader":"styles_loader__Y4Pyp"};